import R from 'ramda'

const REACTION_ON_DISPLAY_TYPE = 'Reaction On'
const REACTION_ON_TRIGGER_TYPE = 'REACTION_ON'

const isReactionOnWidgetTrigger = R.propEq('type', REACTION_ON_TRIGGER_TYPE)

const convertReactionOnWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(REACTION_ON_DISPLAY_TYPE),
  value: R.prop('data')
})

export {
  isReactionOnWidgetTrigger,
  convertReactionOnWidgetTriggerToFormTrigger
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/widget-to-form/reaction-on.js